export default __webpack_public_path__ + "static/media/categorie_entrepreunariat.fd61fefe.jpg";